export const DB_TYPE = {
    CUSTOMIZE: 0,
    MASTER: 1,
    IDEA: 2,
    SERVICE_LINK: 3,
}
